// Which payment types are billed against a reference year, and which of those
// by the month (#540). 'mensalidade' is the monthly payment of the one
// organisation that has the type (named 'renda' until #704); the form, the
// advice request and the lists used to test for the literal 'quota', so a
// monthly payment carried no year and settled nothing.

const yearlyTypes = ['quota', 'mensalidade']
const monthlyTypes = ['mensalidade']

export const hasReferenceYear = (type) => yearlyTypes.includes(type)

export const hasReferenceMonth = (type) => monthlyTypes.includes(type)

// Whether a payment of this type gets a fiscal document (#172). Títulos de
// capital are a share of the cooperative's capital, not a sale. Mirrors
// invoicing.Invoiceable in the API, which refuses them whatever the screen does.
export const isInvoiceable = (type) => type !== 'títulos de capital'

// The month (1..12) a pending is for, read off the date as the API wrote it.
// Going through `new Date()` would move a pending dated the 1st at midnight
// into the month before for any browser west of the server.
export const referenceMonthOf = (date) => {
  const month = parseInt(String(date).slice(5, 7), 10)
  return month >= 1 && month <= 12 ? month : undefined
}

// How a list names what a payment is for: the year, or month/year when the
// payment says which month.
export const referencePeriod = (year, month) => {
  if (year === null || typeof year === 'undefined') return year
  if (month >= 1 && month <= 12) return `${String(month).padStart(2, '0')}/${year}`
  return year
}
